import { useIsApiFeatureFlagEnabled } from '../../../api/me/useIsApiFeatureFlagEnabled';
import { useIsCorpUserApi } from '../../../api/me/claimsApi';
import { useEnableUrlFeatureFlag } from '../../useEnableUrlFeatureFlag/useEnableUrlFeatureFlag';
import { useIsUrlFeatureFlagEnabled } from '../../useIsFeatureFlagEnabled/useIsUrlFeatureFlagEnabled';
import { isVisibleOnFeatureToggleUI } from './isVisibleOnFeatureToggleUI';
import { isFeatureEnabled } from './isFeatureEnabled';
/**
 * This is an all-in-one controller for a single feature flag.
 * It combines the URL feature flagging system with the claims API
 * feature flagging system.
 *
 * - Claims flagging is used for flighting, canary, and A/B testing.
 * - URL flagging is used for local development and diagnosis, or to
 * let power-users manually enable features.
 */
export const useFeature = ({ featureName, apiFeatureName = featureName, enabledByDefault, showInFeatureToggleUI: externalShowInFeatureToggleUI, description, label, enabled: isFeatureEnabledExternally, isInternalOnly, }) => {
    const isUrlFeatureFlagEnabled = useIsUrlFeatureFlagEnabled(featureName);
    const { data: isClaimsFeatureFlagEnabled, isLoading } = useIsApiFeatureFlagEnabled(apiFeatureName);
    const onChange = useEnableUrlFeatureFlag(featureName);
    const { data: isInternalUser } = useIsCorpUserApi();
    // Some day we should have more logic here and not just base
    // disabled state on whether the feature is GA via claims.
    const canDisable = !isClaimsFeatureFlagEnabled;
    const enabled = isFeatureEnabled({
        isFeatureEnabledExternally,
        isUrlFeatureFlagEnabled,
        isClaimsFeatureFlagEnabled,
        isInternalUser,
        isInternalOnly,
    });
    const showInFeatureToggleUI = isVisibleOnFeatureToggleUI({
        isInternalOnly,
        isInternalUser,
        showInFeatureToggleUI: externalShowInFeatureToggleUI,
    });
    return {
        description,
        label,
        isInternalOnly,
        isLoading,
        enabled,
        canDisable,
        isClaimsFeatureFlagEnabled,
        isUrlFeatureFlagEnabled,
        onChange,
        featureName,
        enabledByDefault,
        showInFeatureToggleUI,
    };
};
